(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ns-market-contact-panel"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-market-detail]').forEach((root) => {
    const form = root.querySelector('[data-market-rfq]');
    const submit = root.querySelector('[data-market-rfq-submit]');
    const status = root.querySelector('[data-market-rfq-status]');
    const contactCard = root.querySelector('[data-market-contact-card]');
    const contactLoading = root.querySelector('[data-market-contact-loading]');
    const contactLoadingStatus = root.querySelector('[data-market-contact-loading-status]');
    const contactRetry = root.querySelector('[data-market-contact-retry]');
    const businessContact = root.querySelector('[data-market-business-contact]');
    const privateContact = root.querySelector('[data-market-private-contact]');
    const sellerLinks = root.querySelector('[data-market-seller-links]');
    const sellerEmail = root.querySelector('[data-market-seller-email]');
    const sellerPhone = root.querySelector('[data-market-seller-phone]');
    const sellerUnavailable = root.querySelector('[data-market-seller-unavailable]');
    const sellerIntro = root.querySelector('[data-market-seller-intro]');
    let sellerType = null;
    const favoriteButtons = [
      ...root.querySelectorAll('[data-market-favorite]'),
      ...[...document.querySelectorAll('[data-market-favorite-trigger]')]
        .filter((button) => button.dataset.marketFavoriteTrigger === root.dataset.marketDetailId)
    ];
    const share = root.querySelector('[data-market-share]');
    const actionStatus = root.querySelector('[data-market-action-status]');
    const csrfCache = window.__nsMarketCsrfCache || new Map();
    window.__nsMarketCsrfCache = csrfCache;

    const validProxyPath = (path) => {
      if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) return false;
      try {
        return new URL(path, window.location.origin).origin === window.location.origin;
      } catch (exception) {
        return false;
      }
    };

    const loadSellerContact = async () => {
      sellerType = null;
      businessContact.hidden = true;
      privateContact.hidden = true;
      sellerLinks.hidden = true;
      sellerEmail.removeAttribute('href');
      sellerPhone.removeAttribute('href');
      sellerPhone.hidden = true;
      sellerUnavailable.hidden = true;
      sellerIntro.hidden = true;
      contactLoading.hidden = false;
      contactLoadingStatus.textContent = root.dataset.contactLoading;
      contactRetry.hidden = true;
      contactCard.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        const path = root.dataset.sellerContactPath;
        if (!validProxyPath(path)) throw new Error('market-contact-path');
        const url = new URL(path, window.location.origin);
        url.searchParams.set('listingId', root.dataset.resourceId);
        const response = await fetch(`${url.pathname}${url.search}`, {
          credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal
        });
        if (!response.ok) throw new Error('market-contact');
        const payload = await response.json();
        if (payload.sellerType === 'BUSINESS') {
          sellerType = 'BUSINESS';
          businessContact.hidden = false;
        } else if (payload.sellerType === 'PRIVATE') {
          if (payload.contact === null) {
            sellerUnavailable.hidden = false;
          } else {
            const { email, phone } = payload.contact;
            if (typeof email !== 'string' || !/^[^\s@?&#%]+@[^\s@?&#%]+\.[^\s@?&#%]+$/.test(email) ||
              (phone !== null && (typeof phone !== 'string' || !/^\+?\d{7,15}$/.test(phone)))) throw new Error('market-contact-invalid');
            sellerEmail.href = `mailto:${email}`;
            if (phone !== null) {
              sellerPhone.href = `tel:${phone}`;
              sellerPhone.hidden = false;
            }
            sellerIntro.textContent = phone === null ? root.dataset.contactIntroEmail : root.dataset.contactIntro;
            sellerLinks.hidden = false;
            sellerIntro.hidden = false;
          }
          sellerType = 'PRIVATE';
          privateContact.hidden = false;
        } else {
          throw new Error('market-contact-payload');
        }
        document.querySelectorAll('[data-market-mobile-cta]').forEach((link) => {
          if (link.getAttribute('href') !== `#${root.dataset.marketDetailId}`) return;
          link.querySelectorAll('[data-market-mobile-label], [data-market-mobile-subtitle]').forEach((label) => {
            label.textContent = sellerType === 'PRIVATE' ? label.dataset.privateLabel : label.dataset.businessLabel;
            label.hidden = false;
          });
        });
        contactLoading.hidden = true;
      } catch {
        contactLoadingStatus.textContent = root.dataset.contactError;
        contactRetry.hidden = false;
      } finally {
        clearTimeout(timeout);
        contactCard.setAttribute('aria-busy', 'false');
      }
    };
    contactRetry.addEventListener('click', loadSellerContact);
    void loadSellerContact();

    const createIdempotencyKey = () => {
      if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
      const bytes = crypto.getRandomValues(new Uint8Array(16));
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      const value = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
      return `${value.slice(0, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}-${value.slice(16, 20)}-${value.slice(20)}`;
    };

    const getCsrf = async (forceRefresh = false) => {
      const path = root.dataset.csrfPath;
      if (!validProxyPath(path)) throw new Error('market-csrf-path');
      if (forceRefresh) csrfCache.delete(path);
      const cached = csrfCache.get(path);
      if (cached && cached.token && cached.expiresAt > Date.now()) return cached.token;
      if (cached && cached.promise) return cached.promise;
      const entry = { token: '', expiresAt: 0, promise: null };
      entry.promise = (async () => {
        const response = await fetch(path, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('market-csrf');
        const payload = await response.json();
        if (!payload || typeof payload.csrfToken !== 'string' || !payload.csrfToken) throw new Error('market-csrf-payload');
        entry.token = payload.csrfToken;
        entry.expiresAt = Date.now() + 120000;
        return entry.token;
      })();
      csrfCache.set(path, entry);
      try {
        return await entry.promise;
      } catch (exception) {
        csrfCache.delete(path);
        throw exception;
      } finally {
        entry.promise = null;
      }
    };

    const securePost = async (path, body, idempotencyKey) => {
      if (!validProxyPath(path)) throw new Error('market-proxy-path');
      const send = async (forceCsrf) => {
        const csrfToken = await getCsrf(forceCsrf);
        return fetch(path, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-NS-Market-CSRF': csrfToken,
            'Idempotency-Key': idempotencyKey
          },
          body: JSON.stringify(body)
        });
      };
      let response = await send(false);
      if (response.status === 403) response = await send(true);
      return response;
    };

    const setFavoriteBusy = (busy) => {
      favoriteButtons.forEach((button) => {
        button.disabled = busy;
        button.setAttribute('aria-busy', String(busy));
      });
    };

    const syncFavoriteState = (saved) => {
      favoriteButtons.forEach((button) => {
        button.setAttribute('aria-pressed', String(saved));
        const label = button.querySelector('[data-market-favorite-label]');
        if (label) label.textContent = saved ? root.dataset.saved : root.dataset.save;
      });
    };

    const loadFavoriteState = async () => {
      if (!favoriteButtons.length) return;
      const path = root.dataset.favoritePath;
      if (!validProxyPath(path)) return;
      const url = new URL(path, window.location.origin);
      url.searchParams.set('listingSource', root.dataset.source);
      url.searchParams.set('listingId', root.dataset.resourceId);
      setFavoriteBusy(true);
      try {
        const response = await fetch(`${url.pathname}${url.search}`, {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (response.status === 401) {
          location.assign(root.dataset.loginUrl);
          return;
        }
        if (!response.ok) throw new Error('market-favorite-read');
        const payload = await response.json();
        if (typeof payload.saved !== 'boolean') throw new Error('market-favorite-payload');
        syncFavoriteState(payload.saved);
      } catch {
        actionStatus.textContent = root.dataset.error;
      } finally {
        setFavoriteBusy(false);
      }
    };

    form.addEventListener('submit', async (event) => {
      const path = root.dataset.quotePath;
      event.preventDefault();
      if (sellerType !== 'BUSINESS') return;
      if (!form.reportValidity()) return;
      const data = new FormData(form);
      const body = {
        listingSource: root.dataset.source,
        listingId: root.dataset.resourceId,
        name: String(data.get('name') || '').trim(),
        email: String(data.get('email') || '').trim(),
        phone: String(data.get('phone') || '').trim(),
        message: String(data.get('message') || '').trim(),
        consentAccepted: data.get('consentAccepted') === 'true',
        consentVersion: root.dataset.consentVersion,
        website: String(data.get('website') || '')
      };
      const idempotencyKey = createIdempotencyKey();
      submit.disabled = true;
      submit.textContent = root.dataset.sending;
      form.setAttribute('aria-busy', 'true');
      status.textContent = '';
      status.removeAttribute('data-state');
      try {
        if (body.listingSource !== 'PRODUCT' || !body.listingId) throw new Error('market-listing');
        if (!body.consentAccepted || !body.consentVersion) throw new Error('market-consent');
        const response = await securePost(path, body, idempotencyKey);
        if (!response.ok) throw new Error('market-rfq');
        status.textContent = root.dataset.success;
        status.dataset.state = 'success';
        form.reset();
      } catch {
        status.textContent = root.dataset.error;
        status.dataset.state = 'error';
      } finally {
        submit.disabled = false;
        submit.textContent = root.dataset.submit;
        form.setAttribute('aria-busy', 'false');
      }
    });

    favoriteButtons.forEach((favorite) => {
      favorite.addEventListener('click', async () => {
        const path = root.dataset.favoritePath;
        const targetSaved = favorite.getAttribute('aria-pressed') !== 'true';
        const body = {
          listingSource: root.dataset.source,
          listingId: root.dataset.resourceId,
          saved: targetSaved,
          website: ''
        };
        const idempotencyKey = createIdempotencyKey();
        setFavoriteBusy(true);
        actionStatus.textContent = '';
        try {
          if (body.listingSource !== 'PRODUCT' || !body.listingId) throw new Error('market-listing');
          const response = await securePost(path, body, idempotencyKey);
          if (response.status === 401) {
            location.assign(root.dataset.loginUrl);
            return;
          }
          if (!response.ok) throw new Error('market-favorite');
          let saved = targetSaved;
          if ((response.headers.get('content-type') || '').includes('application/json')) {
            const payload = await response.json();
            if (typeof payload.saved === 'boolean') saved = payload.saved;
          }
          syncFavoriteState(saved);
          actionStatus.textContent = saved ? root.dataset.saved : '';
        } catch {
          actionStatus.textContent = root.dataset.error;
        } finally {
          setFavoriteBusy(false);
        }
      });
    });
    void loadFavoriteState();

    share.addEventListener('click', async () => {
      try {
        if (navigator.share) {
          await navigator.share({ title: document.title, url: location.href });
        } else {
          await navigator.clipboard.writeText(location.href);
        }
        actionStatus.textContent = root.dataset.shareSuccess;
      } catch (exception) {
        if (exception && exception.name === 'AbortError') return;
        actionStatus.textContent = root.dataset.shareError;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ns-market-filter-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-market-filter-form]').forEach((form) => {
    const price = form.querySelector('[data-market-price]');
    const minimum = form.querySelector('[data-market-price-min]');
    const maximum = form.querySelector('[data-market-price-max]');

    const restoreRequestedValues = () => {
      const query = new URLSearchParams(window.location.search);

      form.querySelectorAll('select[name]').forEach((select) => {
        const requested = query.get(select.name);
        if (!requested) {
          select.value = '';
          return;
        }

        if (![...select.options].some((option) => option.value === requested)) {
          const requestedOption = new Option(requested, requested, true, true);
          requestedOption.dataset.requestedValue = 'true';
          select.append(requestedOption);
        }
        select.value = requested;
      });

      if (price && minimum && maximum) {
        const currentMinimum = query.get(minimum.name) || minimum.value;
        const currentMaximum = query.get(maximum.name) || maximum.value;
        const requestedRange = `${currentMinimum || ''}:${currentMaximum || ''}`;
        if ([...price.options].some((option) => option.value === requestedRange)) {
          price.value = requestedRange;
        }
      }
    };

    if (price && minimum && maximum) {
      const syncPrice = () => {
        const values = price.value.split(':');
        minimum.value = values[0] || '';
        maximum.value = values[1] || '';
      };
      price.addEventListener('change', syncPrice);
      form.addEventListener('submit', syncPrice);
    }

    restoreRequestedValues();
    window.addEventListener('pageshow', restoreRequestedValues);

    form.addEventListener('submit', () => {
      form.querySelectorAll('select[name], input[type="hidden"]').forEach((control) => {
        if (!control.value) control.disabled = true;
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
